export default __webpack_public_path__ + "static/media/ff-demo.9dfa0943.mp4";